import React, {Component} from "react";
import "../assets/css/custom/header.css";
import {locales} from "../store/localization/locales";
import {withTranslation} from "react-i18next";
import {logout, changeLanguage} from "../store/rootAction"
import history from "../routes/history"
import {connect} from "react-redux";
import axios from "axios"
import LoadingBar from "react-redux-loading-bar"
import {env} from "../env"
import {getUser} from "../utils/cached";
import ShowUpdateVersion from "../components/version/ShowUpdateVersion";
import Header888 from "./header/Header888";
import Header999 from "./header/Header999";
import {pfType999} from "../constants/general";
import {storage, STORAGE_KEYS} from "../utils/storage";

class HeaderWrapper extends Component {


    logout(e) {
        e.preventDefault()
        this.props.logout()
        storage.set(STORAGE_KEYS.user, "");
        storage.set(STORAGE_KEYS.accessToken, "");
        delete axios.defaults.headers.common["Authorization"]
        history.replace("/login")
    }

    onChangLanguage(lang) {
        const {i18n} = this.props;
        this.props.changeLanguage({languageCode: lang})
            .then(response => {
                window.location.reload()
                i18n.changeLanguage(lang);
            })
    }

    listLocales() {
        const list = [];
        locales().forEach((element) => {
            return list.push(
                <img
                    onClick={(e) => this.onChangLanguage(element.lang)}
                    key={element.lang}
                    className="dropbtn-item"
                    width="50"
                    src={element.flag}
                    alt="..."
                />
            );
        });
        return list;
    }

    render() {
        let platform = env.PLATFORM_FOR;
        let platformType = env.PLATFORM_TYPE;

        const user = getUser();
        const isLotteryMix = this.props.location.pathname === "/lottery-mix"

        return (
            <>
                <ShowUpdateVersion/>
                <div className={`w-100 head ${pfType999 ? "h-header" : ""}`}>
                    <LoadingBar style={{backgroundColor: '#448', height: '5px'}}/>
                    {
                        pfType999 ? <Header999
                            logout={this.logout.bind(this)}
                            username={user?.username}
                            platform={platform}
                            platformType={platformType}
                            isLotteryMix={isLotteryMix}
                            listLocales={this.listLocales()}
                            {...this.props}
                        /> : <Header888
                            logout={this.logout.bind(this)}
                            username={user?.username}
                            platform={platform}
                            platformType={platformType}
                            isLotteryMix={isLotteryMix}
                            listLocales={this.listLocales()}
                            {...this.props}
                        />
                    }
                </div>
            </>
        );
    }
}


const mapStateToProps = state => ({
    ...state.user
})

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(logout()),
    changeLanguage: payload => dispatch(changeLanguage(payload))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(HeaderWrapper))
